// Feature toggles used in this repository

export const FEATURE_SHOW_SUBSCRIPTION_FILTERS = 'feature.intersect.support.showSubscriptionFilters';
export const FEATURE_VIEW_EDIT_CC_PROFILE = 'feature.intersect.support.viewEditCCProfile';
export const REMOVE_DIVERSITY_FILTERS = 'feature.intersectHE.diversity.removeAllFilters';
